import { MyGameItem } from '../models';

export function sortMyGamesDesc(items: readonly MyGameItem[]): MyGameItem[] {
  return [...items].sort(
    (a: MyGameItem, b: MyGameItem) => new Date(b.gameDateStart).getTime() - new Date(a.gameDateStart).getTime()
  );
}
